module.exports = __webpack_public_path__ + "img/dp_world_logo_black.cbfe2b36.png";